import { types } from 'mobx-state-tree';
import validator from 'validator';

const LoginStore = types
  .model('loginStore', {
    isLoading: false,
    email: '',
    password: '',
    error: '',
  })
  .actions(self => ({
    setEmail(email) {
      self.email = email;
    },
    setPassword(password) {
      self.password = password;
    },
    setErrorMessage(errorMsg) {
      self.error = errorMsg;
    },
    setIsLoading(loading) {
      self.isLoading = loading;
    },
    resetLoginStore() {
      self.email = '';
      self.password = '';
      self.error = '';
      self.isLoading = false;
    },
  }))
  .views(self => ({
    get isValidEmail() {
      return validator.isEmail(self.email);
    },
    get isValidPassword() {
      return !validator.isEmpty(self.password);
    },
    get canLogin() {
      return self.isValidEmail && self.isValidPassword;
    },
  }));

export default LoginStore;



// WEBPACK FOOTER //
// ./src/stores/LoginStore.js